module.exports = __webpack_public_path__ + "img/card-payment.8f637a57.png";